import {
  checkProductIsNDEAppConfection,
  checkProductIsNDEConfection,
  checkProductIsNDELayoutConfection,
  checkProductIsNDEPersonalizedConfection,
  checkProductIsNDEPackagingConfection,
  NDE_CONFECTION,
} from '@/utils/categoryUtils';
import { confectionType } from '@/utils/constants/confection';

export const getNDEConfectionTypeOrder = () => [
  confectionType.APP,
  confectionType.PACKAGING,
  confectionType.PERSONALIZED,
  confectionType.LAYOUT,
];

export const getConfectionHeader = (type) => {
  switch (type) {
    case confectionType.APP:
      return 'Personalizacja na maxa';
    case confectionType.LAYOUT:
      return 'Ułożenie kart w paczkach';
    case confectionType.PACKAGING:
      return 'Opcje personalizacji opakowania karty';
    case confectionType.PERSONALIZED:
      return 'Nadruk na opakowaniu';
    default:
      return '';
  }
};

export const isConfectionTypeExclusive = type => type === confectionType.PERSONALIZED;

export const isConfectionAmountEnterable = item => item.product_category === NDE_CONFECTION.SUBPACKAGES;

export const isConfectionReadOnly = item => item.product_category === NDE_CONFECTION.LOGO;

export const getNDEConfectionByType = (product, type) => {
  if (!product) return [];

  switch (type) {
    case confectionType.APP:
      return (product.confection || []).filter(checkProductIsNDEAppConfection);
    case confectionType.LAYOUT:
      return (product.confection || []).filter(checkProductIsNDELayoutConfection);
    case confectionType.PACKAGING:
      return (product.confection || []).filter(checkProductIsNDEPackagingConfection);
    case confectionType.PERSONALIZED:
      return product.confectionService || [];
    default:
      return [];
  }
};

export const isAnyNDEConfectionSelected = (cart) => {
  if (!cart) return false;

  const selectedConfectionIds = cart.filter(checkProductIsNDEConfection).filter(item => item.quantity > 0);
  return selectedConfectionIds.length > 0;
};

export const getSelectedNDEConfectionIdsByType = (cart, type) => {
  if (!cart) return [];

  const filterFunction = (item) => {
    switch (type) {
      case confectionType.APP:
        return checkProductIsNDEAppConfection(item);
      case confectionType.LAYOUT:
        return checkProductIsNDELayoutConfection(item);
      case confectionType.PACKAGING:
        return checkProductIsNDEPackagingConfection(item);
      case confectionType.PERSONALIZED:
        return checkProductIsNDEPersonalizedConfection(item);
      default:
        return false;
    }
  };

  return cart.filter(filterFunction).filter(item => item.quantity > 0).map(item => item.id);
};

export const hasNDEConfectionByType = (product, type) => getNDEConfectionByType(product, type).length > 0;
